export const Balance: TAnt.TableColumnRender<string> = (balance) => <>{balance} MDT</>
